import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { AllstarUser } from "MVVM/State";
import { IUser } from "MVVM/@types";

export const useIsFollowingUser = (userId: string | undefined): boolean => {
  const allstarUser = useRecoilValue(AllstarUser);

  const isFollowing = useMemo(() => {
    if (
      !userId ||
      !allstarUser?.loggedIn ||
      !allstarUser?.followers?.following
    ) {
      return false;
    }

    const followingIds = allstarUser.followers.following.map(
      (user: IUser) => user._id,
    );
    return followingIds.includes(userId);
  }, [userId, allstarUser?.followers?.following, allstarUser?.loggedIn]);

  return isFollowing;
};
